import React, { PropTypes } from 'react';
import { pure } from 'recompose';
import $ from 'jquery';
import {
  InfiniteLoader,
  AutoSizer,
  WindowScroller,
  Table,
  SortDirection,
} from 'react-virtualized';
import rowRenderer from './rowRenderer';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Loader from 'common/components/Loader';
import { bindMouseEvent } from 'utils/mouse-wheel';

const $secondaryMenu = $('section.customers .secondary.menu');

const listHeight = (rows, headerHeight, rowHeight, pageHeight) => {
  let maxHeight;
  if ($secondaryMenu.length) {
    maxHeight = pageHeight - 218;
  } else {
    maxHeight = pageHeight - 158;
  }

  const expectedHeight = rows * rowHeight + headerHeight;

  // Ensure total rows height is not exceeding max page height
  return Math.min(expectedHeight, maxHeight);
};

class InfiniteList extends React.Component {
  static propTypes = {
    hasNextPage: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool.isRequired,
    list: ImmutablePropTypes.list.isRequired,
    loadNextPage: PropTypes.func.isRequired,
    sortPage: PropTypes.func.isRequired,
    sortDirection: PropTypes.string,
    renderColumns: PropTypes.func.isRequired,
    onRowClick: PropTypes.func.isRequired,
    headerHeight: PropTypes.number,
    rowHeight: PropTypes.number,
    customRowRenderer: PropTypes.func,
  };

  static defaultProps = {
    headerHeight: 48,
    rowHeight: 46,
    sortDirection: SortDirection.ASC,
  };

  constructor(props) {
    super(props);

    this.onSortRow = this.onSortRow.bind(this);
  }

  componentDidMount() {
    bindMouseEvent(window, (evt, delta) => {
      const $grid = $('.ReactVirtualized__Table__Grid');
      const currentScroll = $grid.scrollTop();

      if (evt.target.className.indexOf('Table') > 0) {
        // Escaping as Flextable already handle scrolling
        return;
      }

      if (delta > 0) {
        $grid.scrollTop(currentScroll - 52);
      } else {
        $grid.scrollTop(currentScroll + 52);
      }
    });
  }

  onSortRow({ sortBy }) {
    const { sortPage, sortDirection } = this.props;
    if (sortPage) {
      // Reset scrolling
      $('.ReactVirtualized__Table__Grid').scrollTop(0);

      this.props.sortPage({ sortBy, sortDirection });
    }
  }

  render() {
    const {
      hasNextPage,
      list,
      isLoading,
      loadNextPage,
      headerHeight,
      rowHeight,
      sortDirection,
      customRowRenderer,
    } = this.props;

    const rendererToUse = customRowRenderer ? customRowRenderer : rowRenderer;

    const rowCount = hasNextPage ? list.size + 1 : list.size;

    const isRowLoaded = ({ index }) => !hasNextPage || index < list.size;

    const getRow = ({ index }) => {
      const result = list.get(index);
      if (result) {
        return result;
      }

      return {};
    };

    const onRowClick = ({ index }) => {
      if (this.props.onRowClick) {
        this.props.onRowClick(getRow({ index }));
      }
    };

    return (
      <div>
        <Loader text="Chargement des données" visible={isLoading} />
        <InfiniteLoader
          isRowLoaded={isRowLoaded}
          loadMoreRows={loadNextPage}
          rowCount={rowCount}
        >
          {({ onRowsRendered, registerChild }) => (
            <AutoSizer disableHeight>
              {({ width }) => (
                <WindowScroller>
                  {({ height, isScrolling, scrollTop }) => (
                    <Table
                      ref={registerChild}
                      height={listHeight(
                        list.size,
                        headerHeight,
                        rowHeight,
                        height
                      )}
                      width={width}
                      headerHeight={headerHeight}
                      onRowsRendered={onRowsRendered}
                      overscanRowCount={120}
                      rowRenderer={rendererToUse}
                      rowCount={list.size}
                      rowHeight={rowHeight}
                      rowGetter={getRow}
                      onRowClick={onRowClick}
                      scrollTop={scrollTop}
                      sort={this.onSortRow}
                      sortDirection={sortDirection}
                    >
                      {this.props.renderColumns(width)}
                    </Table>
                  )}
                </WindowScroller>
              )}
            </AutoSizer>
          )}
        </InfiniteLoader>
      </div>
    );
  }
}

export default pure(InfiniteList);



// WEBPACK FOOTER //
// ./src/modules/common/components/InfiniteList.js